import { render, staticRenderFns } from "./ListIngredients.vue?vue&type=template&id=027ce2d2&scoped=true&"
import script from "./ListIngredients.vue?vue&type=script&lang=js&"
export * from "./ListIngredients.vue?vue&type=script&lang=js&"
import style0 from "./ListIngredients.vue?vue&type=style&index=0&id=027ce2d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027ce2d2",
  null
  
)

export default component.exports